__turbopack_context__.v({
  "emptyContainer": "WalletHistory-module__dn3UYq__emptyContainer",
  "emptyText": "WalletHistory-module__dn3UYq__emptyText",
  "emptyTitle": "WalletHistory-module__dn3UYq__emptyTitle",
  "loading": "WalletHistory-module__dn3UYq__loading",
  "root": "WalletHistory-module__dn3UYq__root",
});
